// extracted by mini-css-extract-plugin
module.exports = {"file_wrapper":"styles_file_wrapper__2RfUZ","input":"styles_input__lwWrI","file_block":"styles_file_block__TNlvs","delete_btn":"styles_delete_btn__W7GQb"};